import { Grid } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header1";
import Footer from "../Footer/footer";

import "./Staking.scss";
import {
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  FormControlLabel,
  Radio,
  TextField,
  InputAdornment,
} from "@mui/material";

import StakingBanner from "../../Img/flexible-staking-banner.png";

import b1 from "../../Img/b1.png";
import b2 from "../../Img/b2.png";
import b3 from "../../Img/b3.png";
import right_arw_orange from "../../Img/right_arw_orange.svg";

import gift from "../../Img/gift.svg";

import consts from "../../constant";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Flexstaking = () => {
  const [calc, setCalc] = useState("1");
  const [expanded, setExpanded] = useState("panel1");

  const handle_accordion = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="flexible-staking">
      <Header />
      <div className="banner">
        <div className="contain-width">
          <Grid container>
            <Grid xs={12} sm={12} md={12} lg={6} xl={6} sx={{ margin: "auto" }}>
              <h1>Flexible Staking</h1>

              <p className="earn"> Earn daily yield & Utilize your staking</p>
              <p className="earn">
                {" "}
                <img src={gift} alt="img" /> Earn <span>Daily </span>Rewards
              </p>

              <div className="b_flx display-1 flex-wrap">
                <Link to={"#"} className="sign_up display-3">
                  Stake Dreamster-Exchange
                </Link>
                <Link to={"#"} className="dash_b display-3">
                  My Stake
                </Link>
              </div>
            </Grid>
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              sx={{ md: { margin: "auto" } }}
            >
              <div className="img_b">
                <img src={StakingBanner} alt="img" className="banner-left" />
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

      <div className="staking-plan-calc block-top-padding">
        <div className="contain-width">
          <div className="staking-plan-calc-content">
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={7}
                className="stack-calc-left"
              >
                <h2 className="h_2">Flexible Staking Plan Calculator</h2>
                <div className="staking-plan-input">
                  <p>Initial Dreamster-Exchange</p>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                    className="staking-plan-input-field"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          className="highlight-text"
                        >
                          Dreamster-Exchange
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div className="display-1 staking-calc-btn">
                    <Button
                      variant="contained"
                      className={calc === "1" ? "highlight-bg" : ""}
                      onClick={() => {
                        setCalc("1");
                      }}
                    >
                      3M
                    </Button>
                    <Button
                      variant="contained"
                      className={calc === "2" ? "highlight-bg" : ""}
                      onClick={() => {
                        setCalc("2");
                      }}
                    >
                      6M
                    </Button>
                    <Button
                      variant="contained"
                      className={calc === "3" ? "highlight-bg" : ""}
                      onClick={() => {
                        setCalc("3");
                      }}
                    >
                      1Y
                    </Button>
                    <Button
                      variant="contained"
                      className={calc === "4" ? "highlight-bg" : ""}
                      onClick={() => {
                        setCalc("4");
                      }}
                    >
                      2Y
                    </Button>
                    <Button
                      variant="contained"
                      className={calc === "5" ? "highlight-bg" : ""}
                      onClick={() => {
                        setCalc("5");
                      }}
                    >
                      5Y
                    </Button>
                  </div>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                      <div className="box ">
                        <Typography
                          variant="body1"
                          gutterBottom
                          sx={{ fontWeight: "500" }}
                        >
                          Flexible Rate (APR)
                        </Typography>
                        <Typography
                          variant="body2"
                          gutterBottom
                          className="small-txt highlight-text"
                        >
                          (Per Month)
                        </Typography>
                        <Typography
                          variant="h5"
                          gutterBottom
                          sx={{ color: "#5FB787 !important" }}
                        >
                          3.0%
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                      <div className="box ">
                        <Typography
                          variant="body1"
                          gutterBottom
                          sx={{ fontWeight: "500" }}
                        >
                          Total Dreamster-Exchange Rewards
                        </Typography>
                        <Typography
                          variant="body2"
                          gutterBottom
                          className="small-txt highlight-text"
                        >
                          (Per Month)
                        </Typography>
                        <Typography variant="h5" gutterBottom>
                          126
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                      <div className="box ">
                        <Typography
                          variant="body1"
                          gutterBottom
                          sx={{ fontWeight: "500" }}
                        >
                          Withdraw Dreamster-Exchange Rewards
                        </Typography>
                        <Typography
                          variant="body2"
                          gutterBottom
                          className="small-txt highlight-text"
                        >
                          (Per Day)
                        </Typography>
                        <Typography variant="h5" gutterBottom>
                          4.2
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={5}>
                <div className="staking-plan-right">
                  <Typography
                    variant="body2"
                    gutterBottom
                    sx={{ textAlign: "center" }}
                  >
                    Total Estimated Earnings
                  </Typography>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    4878
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <section className="build">
        <div className="contain-width">
          <h2 className="h_2">Claim your Rewards</h2>
          <Grid container spacing={2} sx={{ justifyContent: "center" }}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h5>Top Up</h5>
                <p>
                  Top up 100 USDT worth of <br /> Dreamster-Exchange to get
                  started.
                </p>
                <Link to={`/trade/${consts?.MainPair}`}>
                  Top-up <img src={right_arw_orange} alt="img" />
                </Link>
                <div className="img_box">
                  <img src={b1} alt="img" />
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h5>Flexible Staking</h5>
                <p>
                  Stake your Dreamster-Exchange on Dreamster-Exchange <br /> for
                  90 days to earn rewards.
                </p>
                <Link to={`/future/${consts?.MainPair}`}>
                  Stake <img src={right_arw_orange} alt="img" />
                </Link>
                <div className="img_box">
                  <img src={b2} alt="img" />
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              <div className="box">
                <h5>Withdraw</h5>
                <p>
                  Complete your KYC and instantly <br /> withdraw your USDT
                  bonanza!
                </p>
                <Link to={`/copytrade`}>
                  Withdraw <img src={right_arw_orange} alt="img" />
                </Link>
                <div className="img_box portfolio">
                  <img src={b3} alt="img" />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
      <section className="faq_sec">
        <div className="contain-width">
          <div className="faq_h">
            <h6>Question & Answer</h6>
            <h2 className="h_2">Frequently Asked Questions (FAQ)</h2>
            <p>Quick Answers to Your Most Common Questions.</p>
          </div>
          <div>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel1"}
              onChange={handle_accordion("panel1")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography component={"h3"}>
                  What is Dreamster-Exchange?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  {" "}
                  Dreamster-Exchange is a global cryptocurrency platform that
                  enables users to trade Bitcoin, Ethereum, BNB,
                  Dreamster-Exchange, and over 150 other cryptocurrencies with
                  security and efficiency.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel2"}
              onChange={handle_accordion("panel2")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography component={"h3"}>
                  Who is the Founder of Dreamster-Exchange?
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel3"}
              onChange={handle_accordion("panel3")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel3d-content"
                id="panel3d-header"
              >
                <Typography component={"h3"}>
                  How Do I Participate in the 25 USDT Bonanza? 
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel4"}
              onChange={handle_accordion("panel4")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel4d-content"
                id="panel4d-header"
              >
                <Typography component={"h3"}>
                  Can I Create Multiple Accounts to Receive More USDT? 
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accrdin"
              expanded={expanded === "panel5"}
              onChange={handle_accordion("panel5")}
            >
              <AccordionSummary
                expandIcon={
                  <svg
                    width="21"
                    height="9"
                    viewBox="0 0 21 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.22512 1L10.3601 8L19.4951 1"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                aria-controls="panel5d-content"
                id="panel5d-header"
              >
                <Typography component={"h3"}>
                  Can I Earn Additional USDT through Referrals? 
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="acc_det">
                <Typography>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                  eget.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Flexstaking;
